import { Injectable } from '@angular/core';
import deepmerge from 'deepmerge';
import { FloorClass } from '../../../models/floor.class';
import { EDPElevatorBank, ElevatorBankProcessed, ElevatorTypes } from './elevator-banks.model';

@Injectable()
export class ElevatorBanksMatrixAdapter {
  public adapt(floors: FloorClass[], elevatorData: EDPElevatorBank[]): ElevatorBankProcessed[][] {
    // NOTE: fill and map required as we need different copies for each element
    const elevatorBankData: { [floorIndex: string]: ElevatorBankProcessed[] } = floors.reduce((acc, floor) => {
      const currentFloorIndex = floor.floorIndex;
      return {
        ...acc,
        [`${currentFloorIndex}`]: deepmerge(
          [],
          this.generateEmptyFloorLevelElevatorSet(elevatorData, currentFloorIndex)
        ),
      };
    }, {});

    let result = Object.values(elevatorBankData);

    if (elevatorData.length > 0) {
      elevatorData.forEach((elevator, index) => {
        const startFloor = floors.find(a => a.floorIndex.toString() === elevator.start_floor);
        const endFloor = floors.find(a => a.floorIndex.toString() === elevator.end_floor);
        if (startFloor != null && endFloor != null) {
          const startFloorIndex = startFloor.floorIndex;
          const endFloorIndex = endFloor.floorIndex;
          const startElevatorSet = elevatorBankData[startFloorIndex.toString()][index];
          const endElevatorSet = elevatorBankData[endFloorIndex.toString()][index];
          startElevatorSet.elevatorType = ElevatorTypes.Start;
          // TODO: review old logic for end floor : endIndex === 0 ? ElevatorTypes.LastStop : ElevatorTypes.Stop;
          endElevatorSet.elevatorType = ElevatorTypes.Stop;

          floors
            .filter(floor => floor.floorIndex < endFloorIndex && floor.floorIndex > startFloorIndex)
            .forEach(floor => {
              const currentElevatorSet = elevatorBankData[floor.floorIndex.toString()][index];
              currentElevatorSet.elevatorType = ElevatorTypes.ThickLine;
            });
        }
      });
      result = Object.values(elevatorBankData).sort(
        (elevatorA, elevatorB) => elevatorB[0].floorIndex - elevatorA[0].floorIndex
      );
    }
    return result;
  }

  generateEmptyFloorLevelElevatorSet(elevatorData: EDPElevatorBank[], floorIndex: number): ElevatorBankProcessed[] {
    return Array(elevatorData.length).fill({ elevatorType: ElevatorTypes.Empty, floorIndex });
  }
}
